import * as tslib_1 from "tslib";
import { DataCollection } from '../data_collection';
var HierarchyOption = /** @class */ (function () {
    function HierarchyOption(param) {
        var _this = this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        var keys = 'gradingRules,gradingCode,codingRules,mainField,parentField';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
    }
    HierarchyOption.prototype.toJSON = function () {
        return Object.assign({}, {
            "gradingRules": this.gradingRules,
            "gradingCode": this.gradingCode,
            "codingRules": this.codingRules,
            "mainField": this.mainField,
            "parentField": this.parentField,
        });
    };
    HierarchyOption.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return HierarchyOption;
}());
export { HierarchyOption };
var Hierarchy = /** @class */ (function (_super) {
    tslib_1.__extends(Hierarchy, _super);
    function Hierarchy(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        var keys = 'hierarchyOption,expendAll,expendLevel,recursive';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                if (key === 'hierarchyOption') {
                    _this[key] = new HierarchyOption(obj[key]);
                }
                else {
                    _this[key] = obj[key];
                }
            }
        });
        return _this;
    }
    Hierarchy.prototype.toJSON = function () {
        var result = {
            "type": "Hierarchy",
            "hierarchyOption": null,
            "expendAll": this.expendAll,
            "expendLevel": this.expendLevel,
            "recursive": this.recursive
        };
        if (this.hierarchyOption) {
            result["hierarchyOption"] = this.hierarchyOption.toJSON();
        }
        return Object.assign({}, _super.prototype.toJSON.call(this), result);
    };
    Hierarchy.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Hierarchy;
}(DataCollection));
export { Hierarchy };
//# sourceMappingURL=hierarchy.js.map